import request, { IServerResponse } from '@/utils/request';
import { MessageGetRes } from './define';

export const getMessage = (id: string): Promise<IServerResponse<MessageGetRes>> =>
    request.post('/api/message/get', { id });
